import i18next from 'i18next'
import { Language } from '~/models'

export function translateClientTabCaption(caption: Record<Language, string>) {
  return caption[i18next.language]
}